import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["form", "startDate", "endDate", "periodSelect"]
  static values = { autoSubmit: { type: Boolean, default: true } }

  connect() {
    // Controller connected
  }

  submit() {
    if (this.autoSubmitValue) {
      this.element.requestSubmit()
    }
  }

  setPeriod(event) {
    const period = event.currentTarget.dataset.period
    if (this.hasPeriodSelectTarget) {
      this.periodSelectTarget.value = period
    }
    this.submit()
  }

  clearFilters() {
    this.element.reset()
    this.submit()
  }

  onSelectChange(event) {
    this.submit()
  }
}
